import Swiper from 'swiper/bundle';

(function ($) {

    let swiper = null;
    function initSwiper() {
        const windowWidth = $(window).width();

        if (windowWidth >= 767 && !swiper) {
            swiper = new Swiper(".section-slider-groups .slider-groups", {
                slidesPerView: 'auto',
                spaceBetween: 24,
                navigation: {
                    nextEl: ".section-slider-groups .swiper-button-next",
                    prevEl: ".section-slider-groups .swiper-button-prev",
                },
                scrollbar: {
                    el: '.section-slider-groups .swiper-scrollbar',
                    draggable: true,
                },
                breakpoints: {
                    300: {
                        spaceBetween: 20,
                    },
                    1439: {
                        spaceBetween: 24,
                    },
                }
            });
        }

        else if (windowWidth < 767 && swiper) {
            swiper.destroy(true, true);
            swiper = null;
        }
    }

    $(window).on('load resize', initSwiper);

})(jQuery);
